function initTabsComponent(sectionId) {
  const el = document.querySelector(`tabs-component-${sectionId}`);
  if (!el) return;

  class TabsComponent extends HTMLElement {
    connectedCallback() {
      this.tabButtons = this.querySelectorAll(`.ai-tabs-nav-button-${sectionId}`);
      this.tabPanels = this.querySelectorAll(`.ai-tab-panel-${sectionId}`);
      this.setupEventListeners();
      this.setupKeyboardNavigation();
    }

    setupEventListeners() {
      this.tabButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          const tabNumber = e.target.dataset.tab;
          this.switchTab(tabNumber);
        });
      });
    }

    setupKeyboardNavigation() {
      this.tabButtons.forEach((button, index) => {
        button.addEventListener('keydown', (e) => {
          let newIndex = index;
          switch (e.key) {
            case 'ArrowLeft': newIndex = index > 0 ? index - 1 : this.tabButtons.length - 1; break;
            case 'ArrowRight': newIndex = index < this.tabButtons.length - 1 ? index + 1 : 0; break;
            case 'Home': newIndex = 0; break;
            case 'End': newIndex = this.tabButtons.length - 1; break;
            default: return;
          }
          e.preventDefault();
          this.tabButtons[newIndex].focus();
          this.switchTab(this.tabButtons[newIndex].dataset.tab);
        });
      });
    }

    switchTab(tabNumber) {
      this.tabButtons.forEach((button) => {
        button.classList.remove('active');
        button.setAttribute('aria-selected', 'false');
      });
      this.tabPanels.forEach((panel) => panel.classList.remove('active'));

      const activeButton = this.querySelector(`[data-tab="${tabNumber}"]`);
      const activePanel = this.querySelector(`[data-panel="${tabNumber}"]`);

      if (activeButton && activePanel) {
        activeButton.classList.add('active');
        activeButton.setAttribute('aria-selected', 'true');
        activePanel.classList.add('active');
      }
    }
  }

  if (!customElements.get(`tabs-component-${sectionId}`)) {
    customElements.define(`tabs-component-${sectionId}`, TabsComponent);
  }
}

// Tab components render as <tabs-component-{id} class="ai-tabs-container-{id}">. Find them by that
// class instead of serialising every section's innerHTML and regex-matching it on each page load.
function initTabsWithin(root) {
  root.querySelectorAll('[class*="ai-tabs-container-"]').forEach((el) => {
    const tag = el.tagName.toLowerCase();
    if (tag.indexOf('tabs-component-') === 0) initTabsComponent(tag.slice('tabs-component-'.length));
  });
}

// Standard page load
document.addEventListener('DOMContentLoaded', () => initTabsWithin(document));

// Theme editor dynamic load
document.addEventListener('shopify:section:load', (event) => initTabsWithin(event.target));
